import HubDbasQuizIntroModule from './HubDbasQuizIntroModule'

export default HubDbasQuizIntroModule
